/**
 * Build the post-login destination for an authenticated React app page.
 *
 * `window.location.pathname` includes BrowserRouter's `/app` basename, so the
 * current pathname must not be prefixed again. Keep the destination app-local
 * as defense in depth; the server also validates the `next` query parameter.
 */
export function appLoginReturnPath(pathname: string, search = ""): string {
  const appPath = pathname === "/app" || pathname.startsWith("/app/")
    ? pathname
    : "/app";
  const query = search.startsWith("?") ? search : "";
  return `${appPath}${query}`;
}
